export enum ListOriginEnum {
  Users = 0,
  AddUsersModal = 1,
}
